import * as React from "react";
import styled from "styled-components";

interface IProps
  extends React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLDivElement>,
    HTMLDivElement
  > {}

const FormFieldWrapperDefault: React.SFC<IProps> = (props) => {
  const { ...DivProps } = props;

  return <div {...DivProps} />;
};

const FormFieldWrapper = styled(FormFieldWrapperDefault)`
  // margin-top: 20px;
  margin-bottom: 20px;
`;

export const PasswordFormFieldWrapper = styled(FormFieldWrapperDefault)`
  // margin-top: 20px;
  margin-bottom: 20px;
  display: flex;
  position: relative;
`;

export const PasswordIconButton = styled.button`
  display: block;
  background: none;
  border: none;
  cursor: pointer;
  font-size: 16px;
  width: 20px;
  height: 20px;
  position: absolute;
  right: 10px
  top: 30px;
  i {
    font-family: "Font Awesome 5 Free";
  }
`;

export default FormFieldWrapper;



// WEBPACK FOOTER //
// ./src/presentation/common/atom/wrapper/form_field_wrapper.tsx